import React from "react"
import { Image } from "../../../common/shared-components/images"
import {
  Address,
  Box,
  Container,
  Content,
  Header,
  Holder,
  ImgHolder,
  Text,
  TextHolder,
  Btn,
  Th,
  Time,
  Direction,
  Table,
  TextColor,
  Line,
  Phone,
} from "./styles"
import { StyledBackgroundSectionDamaske } from "./backgroundDamaske"
import { useIntl } from "gatsby-plugin-react-intl"
import i18n from "../i18n"

const LocationDamaske = () => {
  return (
    <Container>
      <Content direction="column-reverse">
        <TextHolder>
          <TextBox />
        </TextHolder>
        <ImgHolder>
          <StyledBackgroundSectionDamaske />
        </ImgHolder>
      </Content>
    </Container>
  )
}

const TextBox = () => {
  const intl = useIntl()
  return (
    <Holder>
      <Header>{intl.formatMessage(i18n.shops.dams.title)}</Header>
      <Text>
        {intl.formatMessage(i18n.shops.dams.desc, {
          break: str => (
            <span>
              <br />
              <br />
              {str}{" "}
            </span>
          ),
        })}
      </Text>
      <Btn>{intl.formatMessage(i18n.shops.dams.termin)}</Btn>
      <Phone>{intl.formatMessage(i18n.shops.dams.phone)}</Phone>
      <Box>
        <Time>
          <TextColor>
            {intl.formatMessage(i18n.shops.dams.openTime.headline)}{" "}
          </TextColor>
          <Table>
            <tbody>
              <tr>
                <Th>{intl.formatMessage(i18n.shops.dams.openTime.day.mon)}</Th>
                <Th>{intl.formatMessage(i18n.shops.dams.openTime.time.mon)}</Th>
              </tr>
              <tr>
                <Th>{intl.formatMessage(i18n.shops.dams.openTime.day.fri)}</Th>
                <Th>{intl.formatMessage(i18n.shops.dams.openTime.time.fri)}</Th>
              </tr>
              <tr>
                <Th>{intl.formatMessage(i18n.shops.dams.openTime.day.sat)}</Th>
                <Th>{intl.formatMessage(i18n.shops.dams.openTime.time.sat)}</Th>
              </tr>
            </tbody>
          </Table>
        </Time>
        <Line />
        <Direction>
          <TextColor>
            {intl.formatMessage(i18n.shops.dams.direction.title)}
          </TextColor>
          <Table>
            <tbody>
              <tr>
                <Th>
                  <div
                    style={{
                      width: "25px",
                      marginRight: ".3rem",
                      filter: "grayscale(100%)",
                    }}
                  >
                    <Image source="sbahn.png" alt="sbahn" />
                  </div>
                </Th>
                <Th>
                  {intl.formatMessage(i18n.shops.dams.direction.info.sbahn)}
                </Th>
              </tr>
              <tr>
                <Th>
                  <div
                    style={{
                      width: "25px",
                      marginRight: ".3rem",
                      filter: "grayscale(100%)",
                    }}
                  >
                    <Image source="ubahn.png" alt="ubahn" />
                  </div>
                </Th>
                <Th>
                  {intl.formatMessage(i18n.shops.dams.direction.info.ubahn)}
                </Th>
              </tr>
              <tr>
                <Th>
                  <div
                    style={{
                      width: "25px",
                      marginRight: ".3rem",
                      filter: "grayscale(100%)",
                    }}
                  >
                    <Image source="bus.png" alt="bus" />
                  </div>
                </Th>
                <Th>
                  {intl.formatMessage(i18n.shops.dams.direction.info.bus)}
                </Th>
              </tr>
            </tbody>
          </Table>
        </Direction>
      </Box>
      <Address>{intl.formatMessage(i18n.shops.dams.address)} </Address>
    </Holder>
  )
}

export default LocationDamaske
